import React from 'react';
import Typography from '@material-ui/core/Typography';
import Refrandom from '../../components/Refrandom';
import { QAs } from './Questions.json';
import Dialog from '@material-ui/core/Dialog';
import SuccessPage from '../../components/PaymentStatus/Success';
import '../galleryStyles.scss';

export class RefrandomPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            payment: undefined,
            price: "0",
            trackCode: "",
            Dialog: false,

        };
        if (this.props.match.params.paymentStatus === "1") {
            this.state.payment = true
            const { price, trackCode } = this.props.match.params;

            if (!price)
                this.state.payment = undefined;
            else
                this.state.price = price;

            if (!trackCode)
                this.state.payment = undefined;
            else
                this.state.trackCode = trackCode;

        }
        else if (typeof (this.props.match.params.paymentStatus) !== "undefined") {
            this.state.payment = false;
            const { price, trackCode } = this.props.match.params;

            if (!price)
                this.state.payment = undefined;
            else
                this.state.price = price;

            if (!trackCode)
                this.state.payment = undefined;
            else
                this.state.trackCode = trackCode;

        }
        else {
            this.state.payment = undefined;
        }
    }

    OnDone = () => {
        if (this.state.payment) this.setState({ Dialog: true });
    }

    OnClose = () => {
        this.setState({
            Dialog: false
        })
    }

    render() {
        return <div className='row fadeUpAn'>
            <div className="col-12 p-5">
                <div className="row">
                    <div className="col-12">
                        <Typography
                            variant='h4'
                            align='center'
                            className='border-bottom pb-4'
                        >
                            پرسشنامه کودک
                        </Typography>
                    </div>
                </div>
                <div className="row pt-5">
                    <div className="col-12">
                        {this.state.Dialog ?
                            <>
                                <Dialog
                                    open={this.state.Dialog}
                                    onClose={this.OnClose}
                                    fullWidth
                                >
                                    <SuccessPage Close={this.OnClose} track={this.state.trackCode} price={this.state.price} />
                                </Dialog>
                            </>
                            : <Refrandom jsonData={QAs} onDone={this.OnDone} />}
                    </div>
                </div>
            </div>
        </div>
    }
}

export default RefrandomPage;